<script setup lang="ts">

import type { HTMLAttributes } from 'vue';

import type { MenuThemeFocusable } from '../types';

interface SubItemClasses {
  class: HTMLAttributes['class'],
  focusable: MenuThemeFocusable
}
defineProps<{
  selected?: boolean,
  open?: boolean,
  classes: SubItemClasses,
}>();

</script>

<template>
  <li :class="[classes.class]">
    <slot
      v-bind="{
        baseClass: [
          classes.focusable.class,
          selected ? classes.focusable.selected : classes.focusable.unselected,
        ],
        selected,
        open,
      }"
    />
  </li>
</template>
